export const DRAWER_WIDTH =200;
export const TOPBAR_HEIGHT = 45;

export const OAUTH2_GOOGLE_STATE_NEXT_PREFIX = 'next_'
